<template>
    <input
        :type="type"
        :id="id"
        :name="name"
        :placeholder="placeholder"
        :value="value"
        :maxlength="length"
        @input="updateValue"
        class="m-form-text"
        :disabled="isDisabled"
        :inputmode="inputmode"
        :class="{'is-disabled': isDisabled}"
        :data-jest-id="`${value}`"
    >
</template>

<script>
    export default {
        name: "FormInputText",
        props: {
            /**
             * inputのタイプ
             */
            type: {
                type: String,
                required: true
            },
            /**
             * id属性
             */
            id: {
                type: String,
                required: false,
                default: ""
            },
            /**
             * name属性
             */
            name: {
                type: String,
                required: true
            },
            /**
             * value属性
             */
            value: {
                type: String,
                required: false,
                default: ""
            },
            /**
             * 擬似プレースホルダー
             * (spanを被せて代用)
             */
            placeholder: {
                type: String,
                required: true
            },
            /**
             * maxlength属性
             * 入力できる最大文字数を指定する
             */
            length: {
                type: String,
                required: false,
                default: ""
            },
            /**
             * 値を入力できる状態か
             */
            isDisabled: {
                type: Boolean,
                require: false,
                default: false
            },
            /**
             * 入力モードの指定
             */
            inputmode: {
                type: String,
                require: false,
                default: 'text'
            }
        },
        emits: ['update:modelValue'],
        methods: {
            updateValue(e) {
                // max-length以上の値をカットする
                let value = e.target.value;
                if (this.length && value > this.length) {
                    value = value.slice(0, this.length)
                }
                this.$emit("update:modelValue", value);

            }
        }
    }
</script>

<style scoped lang="scss">
    @use "../../../scss/v2/base/variables";
    .m-form-text {
        &.is-disabled {
            background: variables.$color-pictlink-fog-15;
            &::placeholder {
                color: variables.$color-pictlink-fog-40;
            }
        }
        &::placeholder {
            color: rgba(variables.$color-pictlink-black-30, variables.$opacity-50);
            font-size: 1.4rem;
        }
    }
</style>
